<header>
  @let authUserData = authUserData$ | async;
  @let user = user$ | async;
  @let userOrgs = userOrgs$ | async;
  @let updateAvailable = versionDetectionEnabled && (updateAvailable$ | async);
  <div class="header-logo">
    <button
      mat-icon-button
      class="hamburger-btn"
      (click)="toggleSidebar()"
      matTooltip="Toggle Sidebar"
      matTooltipPosition="below"
      *ngIf="authUserData?.userRole !== 'SuperAdmin'"
    >
      <mat-icon>menu</mat-icon>
    </button>

    <img src="assets/images/Nabsys_Navigator_logo_e8cc8314.svg" alt="logo" i18n-alt class="logo_icon" />
  </div>

  <mat-tab-group
    *ngIf="authUserData?.userRole === 'SuperAdmin'"
    [selectedIndex]="selectedTabIndex"
    (selectedTabChange)="onTabChange($event)"
    class="navbar header-nav-tabs"
  >
    <!-- Dummy tab(hidden by css) at index 0 is a workaround to allow for a "no tab selected" state. -->
    <mat-tab></mat-tab>
    <mat-tab *ngFor="let tab of visibleTabs" [label]="tab"></mat-tab>
  </mat-tab-group>

  <div class="account-help">
    <div
      class="account"
      *ngIf="authUserData?.userRole !== 'SuperAdmin'"
      [matMenuTriggerFor]="menu3"
      id="action-menu-btn"
    >
      <app-icons class="org-icon" [ariaHidden]="ariaHidden" [ariaLabel]="ariaLabel" [icon]="organization"></app-icons>
      <p i18n>{{ user?.orgName }}</p>

      <app-icons [ariaHidden]="ariaHidden" [ariaLabel]="ariaLabel" [icon]="dropdown" class="dropdown"></app-icons>
    </div>
    <div class="account" [matMenuTriggerFor]="menu2" id="action-menu-btn">
      <p i18n>{{ user?.name }}</p>
      <span class="account-icon-wrap">
        <app-icons [ariaHidden]="ariaHidden" [ariaLabel]="ariaLabel" [icon]="account"></app-icons>
        <span class="update-dot" *ngIf="updateAvailable" aria-hidden="true"></span>
      </span>

      <app-icons [ariaHidden]="ariaHidden" [ariaLabel]="ariaLabel" [icon]="dropdown" class="dropdown"></app-icons>
    </div>
    <mat-menu #menu2="matMenu" class="action-menu-div custom_menu account-menu">
      <div class="username-email">
        <p>
          <strong i18n>{{ user?.name }}</strong>
        </p>
        <p i18n class="email">{{ user?.email }}</p>
      </div>
      <div class="version-update" *ngIf="updateAvailable">
        <p class="version-update__message" i18n="@@appUpdateBanner">A new version of the app is available.</p>
        <button type="button" class="version-update__refresh" (click)="reloadApp()" i18n="@@appUpdateRefresh">
          Refresh to update
        </button>
      </div>
      <div class="custom_menu_items">
        <div mat-menu-item class="mat_item" [routerLink]="['/user']">
          <app-icons [ariaHidden]="ariaHidden" [ariaLabel]="ariaLabel" [icon]="account"></app-icons>
          <p i18n>My Profile</p>
        </div>
        <div mat-menu-item class="mat_item" [routerLink]="['/change-password']">
          <app-icons [ariaHidden]="ariaHidden" [ariaLabel]="ariaLabel" [icon]="lock"></app-icons>
          <p i18n>Change Password</p>
        </div>
        <div mat-menu-item class="mat_item" (click)="logout()">
          <app-icons [ariaHidden]="ariaHidden" [ariaLabel]="ariaLabel" [icon]="logout_icon"></app-icons>
          <p i18n>Logout</p>
        </div>
      </div>
    </mat-menu>

    <mat-menu #menu3="matMenu" class="action-menu-div custom_menu">
      <div class="mat_title" i18n>Your organization</div>

      <div
        mat-menu-item
        class="mat_item"
        *ngFor="let org of userOrgs"
        (click)="selectOrganization(org.orgId)"
        [class.selected]="authUserData?.orgId === org.orgId"
      >
        <mat-icon *ngIf="authUserData?.orgId === org.orgId" class="check-icon">check</mat-icon>
        <span i18n>{{ org.orgName }}</span>
      </div>
    </mat-menu>

    <div class="icon">
      <a href="assets/pdf/755-00026-001 — Nabsys Navigator User Guide — Rev B — v4.pdf" target="_blank">
        <app-icons [ariaHidden]="ariaHidden" [ariaLabel]="ariaLabel" [icon]="help"></app-icons
      ></a>
    </div>
  </div>
</header>
